export default __webpack_public_path__ + "static/media/Lighting.db7fdf4d.jpg";